/* eslint-disable */ import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const meredithSingleFeetBaseComponents = [
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('MeredithSingleFeetBase').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=meredith-single-feet-base.js.map